<template>
  <div>
    <div :class="`${randomId}`" v-html="text"></div>
    <!-- <Modal
      :transition-names="[]"
      fullscreen
      title="Файл байршуулагч"
      v-model="fileUploaderVisible"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <uploader
        @on-success="handleSuccess"
        @on-attach="handleAttach"
        ref="uploader"
        :propFolderId="propFolderId"
        :propBoxId="propBoxId"
        :propObjectTypeId="propObjectTypeId"
        :propObjectId="propObjectId"
      ></uploader>
    </Modal> -->
  </div>
</template>

<script>
import Axios from "axios";
//import Cookies from "js-cookie";
//import { FileInheritedDetail } from "@/api/media";
// import uploader from "@/view/modules/media/component/uploader";

// import AsyncLoadError from "@/components/base/asyncLoadingError";
// import AsyncLoading from "@/components/base/asyncLoading";

import { getToken } from "@/libs/util";
var $ = window.$;
//const moment = require("moment");
export default {
  props: {
    text: {
      type: String,
      default: () => ""
    },
    visible: {
      type: Boolean,
      default: () => false
    },
    propFolderId: {
      type: Number,
      default: () => null
    },
    propBoxId: {
      type: Number,
      default: () => 0
    },
    propObjectTypeId: {
      type: Number,
      default: () => 6
    },
    propObjectId: {
      type: String,
      default: () => "0"
    }
  },
  //   components: {
  //     uploader,
  //     simpleUploader: () => ({
  //       component: import(
  //         "@/view/modules/media/component/uploader/simpleUploader.vue"
  //       ),
  //       loading: AsyncLoading,
  //       error: AsyncLoadError,
  //       delay: 100,
  //       timeout: 5000
  //     })
  //   },
  mounted() {
    if (
      this.$store.state.app.activeGroup.baseUrl != undefined &&
      this.$store.state.app.activeGroup.baseUrl != ""
    ) {
      this.baseURL = this.$store.state.app.activeGroup.baseUrl;
    }

    this.randomId = "summernote_" + this.makeid(10);
    this.buttonId = "mkflbtn_" + this.makeid(10);
    this.init();
  },
  data() {
    return {
      fileUploaderVisible: false,
      randomId: "",
      buttonId: "",
      modalUploadData: {
        render: false,
        show: false,
        attachmentId: 0,
        attachmentUrl: "",
        attachmentName: ""
      },
      baseURL: "https://mobcore.gosmart.mn/"
    };
  },
  methods: {
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    // cancel() {
    //   this.fileUploaderVisible = false;
    // },
    // ok() {
    //   this.fileUploaderVisible = false;
    // },
    // handleSuccess(res) {
    //   this.prepareHtml(
    //     res.response.data.uploadedExt,
    //     res.response.data.uploadedUrl,
    //     res.response.data.uploadedName
    //   );
    //   this.fileUploaderVisible = false;
    // },
    // handleAttach(e) {
    //   FileInheritedDetail({ id: e.id }).then(res => {
    //     this.prepareHtml(
    //       res.data.file.ext,
    //       res.data.file.link,
    //       res.data.file.title
    //     );
    //   });
    //   this.fileUploaderVisible = false;
    // },
    prepareHtml(ext, url, name) {
      ext = ext.toLowerCase();
      if (ext == "pdf") {
        $("." + this.randomId).summernote(
          "pasteHTML",
          `<iframe style='border:0' src='${url}#toolbar=0&navpanes=0&scrollbar=0' width='100%' height='600px'></iframe>`
        );
      } else if (
        ext == "jpg" ||
        ext == "jpeg" ||
        ext == "png" ||
        ext == "bmp" ||
        ext == "gif"
      ) {
        $("." + this.randomId).summernote(
          "pasteHTML",
          `<img    src='${url}?w=1200' />`
        );
      } else {
        $("." + this.randomId).summernote(
          "pasteHTML",
          `<a target='_blank' href='${url}'>${name}</a>`
        );
      }
    },

    init() {
      let self = this;
      this.$nextTick(() => {
        $("." + this.randomId).summernote({
          fontNames: [
            "Arial",
            "Arial Black",
            "Comic Sans MS",
            "Courier New",
            "Times new roman",
            "Roboto Condensed"
          ],
          toolbar: [
            ["font", ["bold", "underline"]],
            ["fontsize", ["fontsize"]],
            ["color", ["color"]],
            ["para", ["ul", "ol", "paragraph"]]
          ],
          callbacks: {
            onChange: function(contents) {
              self.$emit("input", contents);
            },
            onImageUpload: function(files, editor, welEditable) {
              self.sendFile(files, editor, welEditable);
            }
          }
        });
      });
    },
    sendFile(files) {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data"
          //Authorization: "Bearer " + Cookies.get(TOKEN_KEY)
        }
      };
      let fd = new FormData();
      //   let r = Math.random()
      //     .toString(36)
      //     .substring(7);
      fd.append("file", files[0]);
      return Axios.post(
        this.baseURL +
          "core/uploader?folderId=-999&boxId=0&objectTypeId=6&objectId=0&mode=0&token=" +
          getToken(),
        fd,
        config
      ).then(res => {
        $("." + this.randomId).summernote(
          "pasteHTML",
          `<img    src='${res.data.data.uploadedUrl}?w=1200' />`
        );
        // $("." + this.randomId).summernote(
        //   "insertImage",
        //   res.data.data.uploadedUrl + "?w=1200",
        //   ""
        // );
      });
    }

    // fileUploaded(e) {
    //   this.modalUploadData.attachmentName = e.response.data.uploadedName;
    //   this.modalUploadData.attachmentUrl = e.response.data.uploadedUrl;
    //   this.modalUploadData.attachmentId = e.response.data.uploadedAttachmentId;
    //   this.curSetting.value = e.response.data.uploadedUrl + "?w=800";
    // }
  }
};
</script>

<style></style>
